<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat class="grey lighten-2">
          <v-toolbar-title class="blue-grey--text text--darken-4">読み込み設定</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed
            color="blue-grey darken-4 grey--text text--lighten-2"
            @click.stop="reset"
          >
            <v-icon small>fa-undo</v-icon>&nbsp;初期値に戻す
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form lazy-validation ref="form" v-model="form.valid">
            <v-row dense>
              <v-col cols="12">
                <v-select required v-model="form.sheet"
                  label="読み込むシートナンバー"
                  :items="getSizeItems"
                  :rules="rules.sheet"
                />
              </v-col>
              <v-col cols="12">
                <v-subheader class="pa-0">読み込むセルの指定</v-subheader>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="form.country"
                  label="留学先の国"
                  mask="A##"
                  :rules="rules.country"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="form.city"
                  label="留学先の都市"
                  mask="A##"
                  :rules="rules.city"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="form.title"
                  label="学校/プログラム名"
                  mask="A##"
                  :rules="rules.title"
                />
              </v-col>
              <v-col cols="12">
                <v-subheader class="pa-0">コース</v-subheader>
              </v-col>
              <template v-for="(item, idx) in getFormCourseItems">
                <v-col cols="4" :key="idx + '_course_title'">
                  <v-text-field v-model="item.title"
                    label="コース名"
                    mask="A##"
                    :rules="rules.course.title"></v-text-field>
                </v-col>
                <v-col cols="4" :key="idx + '_course_size'">
                  <v-text-field v-model="item.size"
                    label="レッスン数"
                    mask="A##"
                    :rules="rules.course.size"></v-text-field>
                </v-col>
                <v-col cols="4" :key="idx + '_course_unit'">
                  <v-text-field v-model="item.unit"
                    label="レッスン単位"
                    mask="A##"
                    :rules="rules.course.unit"></v-text-field>
                </v-col>
              </template>
              <v-col cols="12">
                <v-subheader class="pa-0">滞在先</v-subheader>
              </v-col>
              <template v-for="(item, idx) in getFormStayItems">
                <v-col cols="6" :key="idx + '_stay_title'">
                  <v-text-field v-model="item.title"
                    label="滞在先名"
                    mask="A##"
                    :rules="rules.stay.title"></v-text-field>
                </v-col>
                <v-col cols="6" :key="idx + '_stay_type'">
                  <v-text-field v-model="item.type"
                    label="宿泊タイプ"
                    mask="A##"
                    :rules="rules.stay.type"></v-text-field>
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          :disabled="!isValid"
          @click.stop="submit">設定する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DEF = {
  SHEET: 3,
  COUNTRY: 'D9',
  CITY: 'D10',
  TITLE: 'L9',
  COURSE: [
    {
      title: 'D15',
      size: 'L15',
      unit: 'M15'
    },
    {
      title: 'D17',
      size: 'L17',
      unit: 'M17'
    },
    {
      title: 'D19',
      size: 'L19',
      unit: 'M19'
    }
  ],
  STAY: [
    {
      title: 'D33',
      type: 'L33'
    },
    {
      title: 'D35',
      type: 'L35'
    }
  ]
}
export default {
  name: 'insertModalLoaderConfig',
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      meta: {
        sizes: new Array(100).fill(null).map((_, i) => (i + 1))
      },
      form: {
        valid: true,
        sheet: DEF.SHEET,
        country: DEF.COUNTRY,
        city: DEF.CITY,
        title: DEF.TITLE,
        courses: JSON.parse(JSON.stringify(DEF.COURSE)),
        stays: JSON.parse(JSON.stringify(DEF.STAY))
      },
      rules: {
        sheet: [ v => !!v || '必須項目です' ],
        country: [
          v => !!v || '必須項目です',
          v => !!(v.length !== 1) || 'セルの値が無効です'
        ],
        city: [
          v => !!v || '必須項目です',
          v => !!(v.length !== 1) || 'セルの値が無効です'
        ],
        title: [
          v => !!v || '必須項目です',
          v => !!(v.length !== 1) || 'セルの値が無効です'
        ],
        course: {
          title: [
            v => !!v || '必須項目です',
            v => !!(v.length !== 1) || 'セルの値が無効です'
          ],
          size: [
            v => !!v || '必須項目です',
            v => !!(v.length !== 1) || 'セルの値が無効です'
          ],
          unit: [
            v => !!v || '必須項目です',
            v => !!(v.length !== 1) || 'セルの値が無効です'
          ]
        },
        stay: {
          title: [
            v => !!v || '必須項目です',
            v => !!(v.length !== 1) || 'セルの値が無効です'
          ],
          type: [
            v => !!v || '必須項目です',
            v => !!(v.length !== 1) || 'セルの値が無効です'
          ]
        }
      }
    }
  },
  methods: {
    open: function () {
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', this.form)
        this.close()
      }
    },
    reset: function () {
      this.$set(this, 'form', {
        valid: true,
        sheet: DEF.SHEET,
        country: DEF.COUNTRY,
        city: DEF.CITY,
        title: DEF.TITLE,
        courses: JSON.parse(JSON.stringify(DEF.COURSE)),
        stays: JSON.parse(JSON.stringify(DEF.STAY))
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    getSizeItems () {
      return this.meta.sizes
    },
    getFormCourseItems () {
      return this.form.courses
    },
    getFormStayItems () {
      return this.form.stays
    }
  }
}
</script>
